
export const storeTowers = towers => dispatch => {
    dispatch({
      type: 'STORE_TOWERS',
      payload: towers,
    });
  };